import { useState, useRef, useCallback } from 'react';
import { saveCategoryConfig } from '../../databaseManager';
import { formatCurrentTime } from '../sharedUtils';

/**
 * Debounced save for CategoryConfig. Automatically stamps updatedAt.
 * Returns { save(config), saving, lastSaved }.
 */
export function useSaveProductConfig(customerId, categoryKey) {
  const [saving, setSaving] = useState(false);
  const [lastSaved, setLastSaved] = useState(null);
  const timerRef = useRef(null);

  const save = useCallback((config) => {
    if (!customerId || !categoryKey) return;
    if (timerRef.current) clearTimeout(timerRef.current);
    timerRef.current = setTimeout(async () => {
      setSaving(true);
      try {
        const stamped = { ...config, updatedAt: formatCurrentTime() };
        await saveCategoryConfig(customerId, categoryKey, stamped);
        setLastSaved(new Date());
      } catch (err) {
        console.error('Failed to save category config:', err);
      } finally {
        setSaving(false);
      }
    }, 1500);
  }, [customerId, categoryKey]);

  return { save, saving, lastSaved };
}
